import React from "react";
import RootStore from "@/stores/index";
var state = {
  rootStore: new RootStore()
};
var StoreContext = /*#__PURE__*/React.createContext(state);
export default StoreContext;